import { Directive, TemplateRef, inject } from '@angular/core';

@Directive({
  selector: '[treeLoadMore]'
})
export class TreeLoadMoreDirective {
  template = inject<TemplateRef<any>>(TemplateRef);
}
